import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Função para formatar a data no formato 'yyyy-MM-ddTHH:mm'
function formatDateTimeLocal(date) {
  const pad = (number) => number.toString().padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

// Função para obter o primeiro dia do mês atual
function getFirstDayOfMonth() {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), 1, 0, 0);
}

// Função para obter o final do dia de hoje
function getEndOfDay() {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59);
}

export const useFilters = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const defaultFilters = {
    descricao: '',
    nome: '',
    dataInicio: formatDateTimeLocal(getFirstDayOfMonth()),
    dataFim: formatDateTimeLocal(getEndOfDay()),
    telefone: '',
    id: '',
    idTransacao: '',
    idpdvs: [],
    status: 'Todos',
    geral: '',
    itensPagina: 20
  };

  const [filters, setFilters] = useState(defaultFilters);
  const [currentPage, setCurrentPage] = useState(1);
  const [filtrado, setFiltrado] = useState(false);

  const loadFiltersFromUrl = () => {
    const queryParams = new URLSearchParams(location.search);
    const page = parseInt(queryParams.get('page')) || 1;
    setCurrentPage(page);
    const isFiltrado = queryParams.get('filtrado') === "true" || false;
    setFiltrado(isFiltrado);

    const newFilters = { ...defaultFilters };
    if (queryParams.size !== 0) {
      for (const key of Object.keys(defaultFilters)) {
        if (queryParams.has(key)) {
          newFilters[key] = queryParams.get(key);
        } else if (key === 'dataInicio') {
          newFilters[key] = '';
        } else if (key === 'dataFim') {
          newFilters[key] = '';
        }
      }
    }
    setFilters(newFilters);
  };

  useEffect(() => {
    loadFiltersFromUrl();
  }, [location.search]);

  const removeEmptyFilters = (filters) => {
    const cleanedFilters = {};
    for (const key in filters) {
      if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined && !(Array.isArray(filters[key]) && filters[key].length === 0)) {
        cleanedFilters[key] = filters[key];
      }
    }
    return cleanedFilters;
  };

  const handlePageChange = (event, pageNumber) => {
    setCurrentPage(pageNumber);
    navigate(`?${new URLSearchParams(removeEmptyFilters({ ...filters, page: pageNumber, filtrado: filtrado })).toString()}`);
  };

  const handleFilter = async (onFilterSuccess) => {
    setCurrentPage(1);
    await setFiltrado(true);
    navigate(`?${new URLSearchParams(removeEmptyFilters({ ...filters, page: currentPage, filtrado: true })).toString()}`);

    if (onFilterSuccess) {
      await onFilterSuccess();
    }
  };

  return {
    filters,
    setFilters,
    currentPage,
    filtrado,
    handlePageChange,
    handleFilter,
    removeEmptyFilters
  };
};
